import AllCustomers from "./AllCustomers";
import './allCustomers.scss';

export default AllCustomers;